import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Usuario } from 'src/app/models/usuario/usuario.model';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { TextosService } from '../../services/textos/textos.service';
import Swal from 'sweetalert2';



declare const Rut: any;
@Component({
  selector: 'app-prestamos',
  templateUrl: '../../pages/prestamos/prestamos-solicitar.html',
  styleUrls: ['../../pages/prestamos/prestamos.component.css']
})
export class PrestamosComponent implements OnInit {
  tipoPrestamo: any
  planes: any
  user: any
  rol: string = localStorage.getItem("rol")
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  tipoPostulacion: string = "Disponibles"
  allComplete: boolean = false
  mostrarPlan: boolean = false
  regiones: any
  estado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  nombreUsuario: any
  rutUsuario: any
  username:any
  totalMaximo: any
  tipos: any
  cuotas: any
  montoTotalCalculado: any
  topeMaximoSolicitado: any
  textos: any
  linkTexto: any
  codeudor: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  codeudor2: any = { rutCodeudor: '', idCodeudor: '', nombreCodeudor: '', apellidoCodeudor: '' };
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '',estadoAfiliado:'' };
  buscador: any =
    {
      rut: '', rut2: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
    }
  prestamo: any = {
    montoSolicitado: '', totalTasa: '', cantidadCuotas: '0', idUsuario: '', idAfiliado: '', idCodeudor1: '',
    idCodeudor2: '', tipoPrestamo: '0', capacidadDescuento: 0, totalReal: '',deshabilitado:false,
    archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null, archivoTest6: null,
    planes: []
  }
 
  calcula: number
  cantidadArchivos: any = 1
  constructor(public router: Router, public prestamosService: PrestamosService, public productosService: ProductosService,
    private dialog: MatDialog,
    private afiliacionService: AfiliacionService, 
    private tiposService: TiposService,private textosService: TextosService) { }

  ngOnInit(): void { this.loadData() }
  loadData() {
    let vm = this
    vm.calcula=0

    this.textosService.obtieneTextos()
    .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "PRESTAMO")?.valor;             
    })
    .catch(error => {
        console.error('Error al obtener los textos:', error);
    });
    
    this.prestamosService.traeTipoPrestamo().then(
      tipo => this.tipos = tipo
    ).catch(error => console.log(error))

    this.prestamosService.traeCantidadCuotas().then(cuota => this.cuotas = cuota).catch(error => console.log(error))

   
    this.nombreUsuario = localStorage.getItem("nombreUsuario");
    this.rutUsuario = localStorage.getItem("rutUsuario") + "-" + localStorage.getItem("dvUsuario");
    this.totalMaximo = 0;
    this.mostrarPlan=false;
    this.productosService.obtieneProductos().then
      (
        productos => productos[3].parametros.map(parametro => {
          if (parametro.descripcion == 'TOPE_MAXIMO_SOLICITADO') {
            this.topeMaximoSolicitado = parametro.valor
          }
        })
      )
      .catch(error => console.log(error))

    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;
      this.afiliado.rutAfiliado = this.rutUsuario;
      this.afiliado.idAfiliado = this.idEjecutivo;


      this.prestamosService.traeMontoTotalDisponible(this.afiliado.idAfiliado).then(
        response => {
          if (response == 0) {
            vm.openAlertDialog('El usuario no tiene un total disponible.', 'btn-danger')
            Swal.close();
          }
          console.log("traeMontoTotalDisponible:",response)
          this.totalMaximo = response;
          this.prestamo.montoSolicitado = response;
          this.actualizarTotalReal(response);

        }
      ).catch(error => {
        console.log(error);
        this.totalMaximo = 0;
      });
      this.prestamosService.traeCapacidadDescuento(this.afiliado.idAfiliado).then(
        response => {

          if (response == 0) {
            vm.openAlertDialog('El usuario no tiene capacidad de descuento.', 'btn-danger')
            Swal.close();
          }
          this.prestamo.capacidadDescuento = response;
        }
      ).catch(error => {
        console.log(error);
        this.totalMaximo = 0;
      });
      vm.calcula=0
      this.afiliacionService.traeSoloAfiliadoSinEstados(this.rutUsuario.split('-')[0]).then
          (
            (response: any) => {
              if(response.estadoAfiliado  && response.estadoAfiliado =='PENDIENTE_DESAFILIACION'){
                vm.openAlertDialog('Usted se encuentra pendiente de desafiliación por lo que no puede postular a este beneficio.', 'btn-danger')
                vm.router.navigate(['/index'])                 
              }
            }
          )
          .catch
          (
              error => {
                console.log('error traeSoloAfiliadoSinEstados:',error);
              }
          )
    


    }
  }
  buscaCodeudor(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]

      this.traePostulantes(rut, ubicacion)
    }
    else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
  }
  actualizarTotalReal(montoTotal: any) {
    this.calcularPlanPagoMontoTotal(montoTotal + 1);

  }
  actualizarTasa(total: any) {
    this.prestamo.totalTasa = total - this.prestamo.montoSolicitado;
  }
  /* Monto Real Solicitado (107290)  - montoSolicitado (100000) */
  limpiarCodeudores() {
    let vm = this;

    vm.codeudor.rutCodeudor = ''
    vm.codeudor.idCodeudor = ''
    vm.codeudor.nombreCodeudor = ''
    vm.codeudor.apellidoCodeudor = ''
    vm.codeudor.rutCodeudor = ''
    vm.codeudor2.rutCodeudor = ''
    vm.codeudor2.idCodeudor = ''
    vm.codeudor2.nombreCodeudor = ''
    vm.codeudor2.apellidoCodeudor = ''
    vm.codeudor2.rutCodeudor = ''
    vm.buscador.rut = ''
    vm.buscador.rut2 = ''


  }

  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.prestamo.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.prestamo.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

      
      }
    }
  }

  sumaArchivo() {
    if (this.cantidadArchivos <= 5) {

      this.cantidadArchivos = this.cantidadArchivos + 1
    }
  }

  restaArchivo() {
    this.cantidadArchivos = this.cantidadArchivos - 1
    this.prestamo.archivo.splice(this.cantidadArchivos, 1);


  }
  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO' && ubicacion==3){  
      this.validarEstado(rut.split('.').join('').split('-')[0])
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.prestamosService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {
          if (ubicacion == 1) {
            if (usuario.tipoAfiliado == 'PASIVO') {
              this.openAlertDialog('El codeudor es del tipo PASIVO.', 'btn-danger')
              Swal.close();
              return false
            }
            if (usuario.estadoAfiliado == 'DESAFILIADO') {
              this.openAlertDialog('El codeudor se encuentra DESAFILIADO.', 'btn-danger')
              Swal.close();
              return false
            }

            vm.codeudor.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor.idCodeudor = usuario.id
          }
          if (ubicacion == 2) {
            if (usuario.tipoAfiliado == 'PASIVO') {
              this.openAlertDialog('El codeudor es del tipo PASIVO.', 'btn-danger')
              Swal.close();
              return false
            }
            if (usuario.estadoAfiliado == 'DESAFILIADO') {
              this.openAlertDialog('El codeudor se encuentra DESAFILIADO.', 'btn-danger')
              Swal.close();
              return false
            }
            vm.codeudor2.nombreCodeudor = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.codeudor2.rutCodeudor = usuario.rut + "-" + usuario.dv
            vm.codeudor2.idCodeudor = usuario.id

          }
          if (ubicacion == 3) {
            vm.afiliado.nombreAfiliado = usuario.nombres + ' ' + usuario.apellidoPaterno
            vm.afiliado.rutAfiliado = usuario.rut + "-" + usuario.dv
            vm.afiliado.idAfiliado = usuario.id
            vm.calcula=0
            this.prestamosService.traeMontoTotalDisponible(vm.afiliado.idAfiliado).then(response => {
        
              this.totalMaximo = response;
              this.prestamo.montoSolicitado = response;
              this.actualizarTotalReal(response);
            }
            ).catch(error => { console.log(error); this.totalMaximo = 0; });
            this.prestamosService.traeCapacidadDescuento(vm.afiliado.idAfiliado).then(response => { this.prestamo.capacidadDescuento = response; }
            ).catch(error => { console.log(error); this.totalMaximo = 0; });
          }

          Swal.close();

        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
      })
  }

  validarEstado(rutAfiliado){
    let vm = this;
    this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
    ( 
        (response: any) => {
            if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                    || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                        console.log(response.estadoAfiliado)
                this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                this.router.navigate(['/index'])                 
            }
        }
    )
    .catch
    (
        error => {
        console.log('error :',error);
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
        }
    ) 
}

  calcularPlanPago() {
  
    let vm = this
    vm.prestamo.deshabilitado=true
    let error = 0;
    vm.calcula=vm.calcula+1;
    let Cantidadcuotas = 10;
    /* se deja valor tope por default, pero el valor real es rescatado de la base de datos*/
    let tope = 500000;
    if (vm.prestamo.montoSolicitado == 0) {
      vm.openAlertDialog('El monto solicitado no puede ser 0.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    console.log("archivo test ", vm.prestamo.archivoTest)
    if (vm.prestamo.archivoTest == null) {
      vm.openAlertDialog('No puede generar un plan de pago sin haber seleccionado un archivo.', 'btn-danger')
      Swal.close();
      error = 1;
    }
    /*
    if(vm.planes.length)
    Cantidadcuotas=vm.planes.length
    
    if( (vm.prestamo.capacidadDescuento * Cantidadcuotas)< this.prestamo.totalReal ){
      vm.openAlertDialog('Monto solicitado excede capacidad de descuento.', 'btn-danger')
      Swal.close();
      error  = 1;
    }
     */
    if (this.topeMaximoSolicitado)
      tope = this.topeMaximoSolicitado
    if (vm.prestamo.montoSolicitado > tope) {
      vm.openAlertDialog('El monto solicitado no debe superar los 500.000.', 'btn-danger')
      Swal.close();
      error = 1;
    }
  
 /*
    if (vm.prestamo.totalReal > vm.totalMaximo || vm.prestamo.totalReal == 0) {
      vm.openAlertDialog('El monto solicitado excede el valor real de endeudamiento.', 'btn-danger')
      Swal.close();
      error = 1;
    }*/

    if (error == 0) {
      vm.montoTotalCalculado = vm.prestamo.montoSolicitado;
      vm.prestamosService.calcularPlanPago(vm.prestamo.montoSolicitado, vm.prestamo.cantidadCuotas).
        then(
          (planes: any) => {
            if (vm.planes.length)
              Cantidadcuotas = vm.planes.length
            
          /*  if(vm.prestamo.capacidadDescuento < planes[0].montoTotalCuota){
              vm.openAlertDialog('El monto solicitado excede el valor real de endeudamiento.', 'btn-danger')
              Swal.close();
              error = 1;
            } */

            if ((vm.prestamo.capacidadDescuento * Cantidadcuotas) < this.prestamo.totalReal) {
              vm.openAlertDialog('Monto solicitado excede capacidad de descuento', 'btn-danger')
              Swal.close();
              error = 1;
            } else {
              this.mostrarPlan=true;
              vm.planes = planes
              vm.config.currentPage = 1
              vm.config.totalItems = planes.length
            }
          }
        )
        .catch(error => {
          console.log(error)
          Swal.close();
          this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-dark')
        })
    }
  }
  calcularPlanPagoMontoTotal(total: any) {
    let vm = this
    vm.montoTotalCalculado = vm.prestamo.montoSolicitado;
    let cantidadCuotas = 23
    vm.prestamosService.calcularPlanPagoMontoTotal(vm.prestamo.montoSolicitado, cantidadCuotas, vm.afiliado.idAfiliado).
      then(
        (planes: any) => {
          console.log("planes:", planes)
          this.prestamo.totalReal = planes;
          this.actualizarTasa(planes);
        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        //        this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-dark')
      })

  }
  solicitar(form: NgForm) {
    let vm = this;
    let usuarioId = localStorage.getItem("idUsuario")
    let idAfiliado = this.afiliado.idAfiliado
    if(vm.calcula==0){
      this.openAlertDialog('Antes de solicitar debe presionar el botón calcular para actualizar el plan de pago.', 'btn-danger')
      Swal.close();
      return false;
    }

    if(!this.planes){
      this.openAlertDialog('Debe seleccionar un plan de pago.', 'btn-danger')
      Swal.close();
      return false;
    }
   

    if ((this.prestamo.capacidadDescuento * 10) < this.prestamo.totalReal) {
      this.openAlertDialog('Monto solicitado excede capacidad de descuento.', 'btn-danger')
      Swal.close();
    } else {
      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
          data: { message: '¿Esta seguro de Ingresar la Solicitud de Préstamo?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
          });
          Swal.showLoading();
          ;


          let sizeArchivos = 0;
          for (let i = 0; i < this.cantidadArchivos; i++) {
            sizeArchivos += this.prestamo.archivo[i].size;
            if (sizeArchivos > 25000000) {
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();
              return;
            }
            this.prestamo.archivo[i].sizeArchivos
            if (this.prestamo.archivo[i].extension != "application/pdf" && this.prestamo.archivo[i].extension != "image/jpeg" &&
              this.prestamo.archivo[i].extension != "image/jpg" && this.prestamo.archivo[i].extension != "image/png") {
              this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')

              Swal.close();
              return false
            }

          }
          

          this.prestamosService.ingresarPrestamo(usuarioId, idAfiliado, this.prestamo,
            this.codeudor, this.codeudor2, this.planes).then(
              () => {
                Swal.close();
                //  this.prestamo.archivo = [];
                this.openAlertDialog('La solicitud de Préstamo fue ingresada exitosamente.', 'btn-success')
                form.reset()
                this.reloadComponent();
              }
            )
            .catch(error => {
              //this.prestamo.archivo = [];
              if (error.status == 406) {
                this.openAlertDialog('Los Codeudores deben ser distintos y también diferentes al solicitante.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 423) {
                this.openAlertDialog('No puede solicitar más préstamos de este tipo.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 402) {
                this.openAlertDialog('Existen problemas de carencia del usuario.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 403) {
                this.openAlertDialog('El monto a solicitar debe ser mayor a 0.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 410) {
                this.openAlertDialog('Ambos codeudores no están autorizados a serlo.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 409) {
                this.openAlertDialog('El codeudor 1 no puede serlo.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 418) {
                this.openAlertDialog('El codeudor 2 no puede serlo.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 411) {
                this.openAlertDialog('El monto a solicitar no debe ser mayor a su tope de deuda.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 417) {
                this.openAlertDialog('La cantidad de cuotas debe ser mayor a 0.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 422) {
                this.openAlertDialog('Debe seleccionar un tipo de préstamo.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 424) {
                this.openAlertDialog('El valor de cuota a pagar debe ser mayor a 0.', 'btn-danger')
                Swal.close();
              }
              if (error.status == 500) {
                this.openAlertDialog('No se pudo ingresar la solicitud de préstamo. Intente nuevamente.', 'btn-danger')
                Swal.close();
              }

              console.log(error)
              // Swal.close();

            })


        }
      })
    }
  }

  actualizaInteres() {
    let vm = this
    vm.montoTotalCalculado = vm.prestamo.montoSolicitado;
    let total = 0;
    vm.prestamosService.calcularPlanPago(vm.prestamo.montoSolicitado, vm.prestamo.cantidadCuotas).
      then(
        (planes: any) => {
          vm.planes = planes
          vm.config.currentPage = 1
          vm.config.totalItems = planes.length
          for (let i = 0; i < planes.length; i++) {
            total = total + planes[i].tasaInteres
          }
          this.prestamo.totalTasa = total
          this.mostrarPlan=false;
        }
      )
      .catch(error => {
        console.log(error)
        Swal.close();
        this.openAlertDialog('No se pudo calcular el plan de pago. Intente nuevamente.', 'btn-dark')
      })

  }
  nuevoMontoCalcular() {
    let vm = this
    vm.prestamo.deshabilitado=false
    vm.calcula=0
  }
  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  limpiarPlanDePago() {
    this.montoTotalCalculado = ''
    this.planes = ''
    this.config.currentPage = 1
    this.config.totalItems = 0


  }
  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  salir() { this.router.navigate(['/index']) }

}



// 